/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, BigNumberish, Overrides } from 'ethers';
import type { Provider, TransactionRequest } from '@ethersproject/providers';
import type { PromiseOrValue } from '../common.js';
import type { TroveBridge, TroveBridgeInterface } from '../TroveBridge.js';

const _abi = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_rollupProcessor',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_initialICRPerc',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'constructor',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
    ],
    name: 'ApproveFailed',
    type: 'error',
  },
  {
    inputs: [],
    name: 'AsyncDisabled',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidCaller',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidDeltaAmounts',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidInput',
    type: 'error',
  },
  {
    inputs: [],
    name: 'InvalidOutputB',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'enum TroveBridge.Status',
        name: 'status',
        type: 'uint8',
      },
    ],
    name: 'InvalidStatus',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MaxCostExceeded',
    type: 'error',
  },
  {
    inputs: [],
    name: 'MissingImplementation',
    type: 'error',
  },
  {
    inputs: [],
    name: 'NonZeroTotalSupply',
    type: 'error',
  },
  {
    inputs: [],
    name: 'OwnerNotLast',
    type: 'error',
  },
  {
    inputs: [],
    name: 'SwapFailed',
    type: 'error',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'token',
        type: 'address',
      },
    ],
    name: 'TransferFailed',
    type: 'error',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'Approval',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'OwnershipTransferred',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256',
      },
    ],
    name: 'Transfer',
    type: 'event',
  },
  {
    stateMutability: 'payable',
    type: 'fallback',
  },
  {
    inputs: [],
    name: 'BORROWER_OPERATIONS',
    outputs: [
      {
        internalType: 'contract IBorrowerOperations',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'DUST',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'INITIAL_ICR',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'LUSD',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'LUSD_USDC_POOL',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'PRECISION',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'ROLLUP_PROCESSOR',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'SORTED_TROVES',
    outputs: [
      {
        internalType: 'contract ISortedTroves',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'SUBSIDY',
    outputs: [
      {
        internalType: 'contract ISubsidy',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'TROVE_MANAGER',
    outputs: [
      {
        internalType: 'contract ITroveManager',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'USDC',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'USDC_ETH_POOL',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'WETH',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'owner',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
    ],
    name: 'allowance',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'approve',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address',
      },
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'closeTrove',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_collateral',
        type: 'uint256',
      },
    ],
    name: 'computeAmtToBorrow',
    outputs: [
      {
        internalType: 'uint256',
        name: 'amtToBorrow',
        type: 'uint256',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    name: 'computeCriteria',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_inputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_inputAssetB',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_outputAssetA',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '_outputAssetB',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: '_totalInputValue',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '_interactionNonce',
        type: 'uint256',
      },
      {
        internalType: 'uint64',
        name: '_auxData',
        type: 'uint64',
      },
      {
        internalType: 'address',
        name: '_rollupBeneficiary',
        type: 'address',
      },
    ],
    name: 'convert',
    outputs: [
      {
        internalType: 'uint256',
        name: 'outputValueA',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: 'outputValueB',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'decimals',
    outputs: [
      {
        internalType: 'uint8',
        name: '',
        type: 'uint8',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'subtractedValue',
        type: 'uint256',
      },
    ],
    name: 'decreaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        components: [
          {
            internalType: 'uint256',
            name: 'id',
            type: 'uint256',
          },
          {
            internalType: 'address',
            name: 'erc20Address',
            type: 'address',
          },
          {
            internalType: 'enum AztecTypes.AztecAssetType',
            name: 'assetType',
            type: 'uint8',
          },
        ],
        internalType: 'struct AztecTypes.AztecAsset',
        name: '',
        type: 'tuple',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint64',
        name: '',
        type: 'uint64',
      },
    ],
    name: 'finalise',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'spender',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'addedValue',
        type: 'uint256',
      },
    ],
    name: 'increaseAllowance',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_upperHint',
        type: 'address',
      },
      {
        internalType: 'address',
        name: '_lowerHint',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: '_maxFee',
        type: 'uint256',
      },
    ],
    name: 'openTrove',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'totalSupply',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'transfer',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address',
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address',
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256',
      },
    ],
    name: 'transferFrom',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool',
      },
    ],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address',
      },
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    inputs: [
      {
        internalType: 'int256',
        name: '_amount0Delta',
        type: 'int256',
      },
      {
        internalType: 'int256',
        name: '_amount1Delta',
        type: 'int256',
      },
      {
        internalType: 'bytes',
        name: '_data',
        type: 'bytes',
      },
    ],
    name: 'uniswapV3SwapCallback',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    stateMutability: 'payable',
    type: 'receive',
  },
];

const _bytecode =
  '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';

type TroveBridgeConstructorParams = [signer?: Signer] | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (xs: TroveBridgeConstructorParams): xs is ConstructorParameters<typeof ContractFactory> =>
  xs.length > 1;

export class TroveBridge__factory extends ContractFactory {
  constructor(...args: TroveBridgeConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _rollupProcessor: PromiseOrValue<string>,
    _initialICRPerc: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): Promise<TroveBridge> {
    return super.deploy(_rollupProcessor, _initialICRPerc, overrides || {}) as Promise<TroveBridge>;
  }
  override getDeployTransaction(
    _rollupProcessor: PromiseOrValue<string>,
    _initialICRPerc: PromiseOrValue<BigNumberish>,
    overrides?: Overrides & { from?: PromiseOrValue<string> },
  ): TransactionRequest {
    return super.getDeployTransaction(_rollupProcessor, _initialICRPerc, overrides || {});
  }
  override attach(address: string): TroveBridge {
    return super.attach(address) as TroveBridge;
  }
  override connect(signer: Signer): TroveBridge__factory {
    return super.connect(signer) as TroveBridge__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TroveBridgeInterface {
    return new utils.Interface(_abi) as TroveBridgeInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): TroveBridge {
    return new Contract(address, _abi, signerOrProvider) as TroveBridge;
  }
}
